<template>
  <div>
    <AppHeader />

    <div class="invoice-update-container">
      <h1>Update</h1>
      
      <div class="customer-info-section">
        <div class="info-row">
          <label>Phone</label>
          <div class="info-value">{{ customer.phone }}</div>
        </div>
        
        <div class="info-row">
          <label>Full name</label>
          <div class="info-value">{{ customer.fullName }}</div>
        </div>
        
        <div class="info-row">
          <label>Total UnPaid</label>
          <div class="info-value">{{ formatCurrency(customer.totalUnpaid) }}</div>
        </div>
      </div>
      
      <div class="payment-section">
        <div class="info-row">
      <label>Amount</label>
      <input 
        type="number" 
        v-model="payment.amount" 
        class="info-value-input"
        @input="validateAmount"
        min="0"
        step="0.01"
        placeholder="Enter amount"
      >
    </div>
        
        <div class="info-row">
          <label>Payments Types</label>
          <div class="info-value">{{ payment.types }}</div>
        </div>
        
        <div class="info-row">
          <label>Discount</label>
          <div class="info-value">{{ payment.discount }}</div>
        </div>
      </div>
      <div class="info-row action-row">
  <button 
    class="btn-update"
    @click="updateBalance"
    :disabled="!payment.amount || payment.amount <= 0"
  >
    Update Balance
  </button>
</div>
      <div class="divider"></div>
      
      <h3>Invoices List</h3>
      
      <div class="invoices-table">
        <div class="table-header">
  <div class="header-cell">Order Id</div>
  <div class="header-cell">Total Amount</div>
  <div class="header-cell">Paid Amount</div>
  <div class="header-cell">Is Paid</div>
  <div class="header-cell">Issued At</div>
</div>
        
        <div class="table-row" v-for="invoice in invoices" :key="invoice.id">
  <div class="table-cell">{{ invoice.orderId }}</div>
  <div class="table-cell">{{ formatCurrency(invoice.totalAmount) }}</div>
  <div class="table-cell">{{ formatCurrency(invoice.paidAmount) }}</div>
  <div class="table-cell">{{ invoice.isPaid ? 'Yes' : 'No' }}</div>
  <div class="table-cell">{{ formatDate(invoice.issuedAt) }}</div>
</div>
      </div>

      <div class="action-buttons">
        <button class="btn btn-secondary" @click="cancelUpdate">Cancel</button>
        <!-- <button class="btn btn-primary" @click="submitUpdate">Update Invoice</button> -->
      </div>
    </div>
  </div>
  </template>
  
<script>
import axios from 'axios';
export default {
  name: 'InvoiceUpdate',
  data() {
    return {
      loading: false,
      error: null,
      customer: {
        phone: '',
        fullName: '',
        totalUnpaid: 0
      },
      payment: {
        amount: '',
        types: 'Cash CCredit',
        discount: 0
      },
      invoices: []
    }
  },
  created() {
  this.token = localStorage.getItem('authToken'); 
    this.userId = localStorage.getItem('userId'); 
    console.log(this.userId);
    this.fetchUserInvoices();
  },
   mounted(){
this.customerId = this.$route.params.customerId;
  },
  methods: {
      async updateBalance() {
    if (!this.payment.amount || this.payment.amount <= 0) {
      this.$toast.error('Please enter a valid amount');
      return;
    }

    try {
      this.$root.isLoading = true;
      
      const response = await axios.post(
        `${this.$BASE_API_URL}/api/customers/edit_balance/${this.customerId}`,
        {
          balance: this.payment.amount,
          note: 'Balance updated via admin panel'
        },
        {
          headers: {
            Authorization: `Bearer ${this.token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data.status) {
        this.$toast.success('Balance updated successfully');
        this.fetchUserInvoices();
        this.payment.amount = '';
      } else {
        throw new Error(response.data.message || 'Failed to update balance');
      }
    } catch (error) {
      console.error('Error updating balance:', error);
      this.$toast.error(error.response?.data?.message || 'Failed to update balance');
    } finally {
      this.$root.isLoading = false;
    }
  },
   async fetchUserInvoices() {
  this.loading = true;
    this.$root.isLoading = true;

  this.error = null;
  
  try {
    const response = await axios.get(`${this.$BASE_API_URL}/api/orders/user-invoices/${this.customerId}`, {
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
    });
    
    if (response.data.status) {
      this.invoices = response.data.data;
      this.calculateCustomerTotals();
    } else {
      throw new Error(response.data.message || 'Failed to fetch invoices');
    }
  } catch (err) {
    this.error = err.response?.data?.message || err.message;
    console.error('Error fetching invoices:', err);
  } finally {
    this.loading = false;
      this.$root.isLoading = false;

  }
},
    calculateCustomerTotals() {
  this.customer.totalUnpaid = this.invoices.reduce((sum, invoice) => {
    return sum + parseFloat(invoice.remainingAmount || 0);
  }, 0);
},
    validateAmount() {
      if (this.payment.amount < 0) {
        this.payment.amount = 0;
      }
      this.payment.amount = parseFloat(this.payment.amount).toFixed(2);
    },
    formatCurrency(value) {
      return parseFloat(value || 0).toFixed(2);
    },
    formatDate(dateString) {
  if (!dateString) return 'N/A';
  const options = { 
    year: 'numeric', 
    month: 'short', 
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  };
  return new Date(dateString).toLocaleString(undefined, options);
},
    cancelUpdate() {
      // Handle cancel logic
    },
    submitUpdate() {
      // Handle submit logic
    }
  }
}
</script>
  <style scoped>
.action-row {
  margin-top: 20px;
  justify-content: center;
}

.btn-update {
  padding: 10px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
}

.btn-update:hover {
  background-color: #45a049;
}

.btn-update:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.info-value-input {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 100%;
  max-width: 200px;
}
  .invoice-update-container {
    font-family: Arial, sans-serif;
    padding: 20px;
    margin: 0 auto;
  }
  .info-value-input {
  flex-grow: 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  width: 100%;
  max-width: 200px; 
}
  
  h1 {
    font-size: 24px;
    margin-bottom: 20px;
  }
  
  h3 {
    font-size: 18px;
    margin: 20px 0 10px;
  }
  
  .info-row {
    display: flex;
    margin-bottom: 10px;
  }
  
  .info-row label {
    font-weight: bold;
    width: 150px;
  }
  
  .info-value {
    flex-grow: 1;
  }
  
  .divider {
    border-top: 1px solid #ccc;
    margin: 20px 0;
  }
  
  .invoices-table {
    width: 100%;
    color: var(--font-color);
    border-collapse: collapse;
    margin-bottom: 20px;
  }
  
  .table-header, .table-row {
    display: flex;
    padding: 8px 0;
  }
  
  .table-header {
    font-weight: bold;
    border-bottom: 2px solid #ccc;
  }
  
  .table-row {
    border-bottom: 1px solid #eee;
  }
  .action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 25px;
}
  .header-cell, .table-cell {
    flex: 1;
    padding: 0 5px;
  }
  
  .search-bar {
    margin-top: 20px;
  }
  
  .search-bar input {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  .loading, .error {
  padding: 20px;
  text-align: center;
  color: #666;
}

.error {
  color: #d9534f;
}

.header-cell, .table-cell {
  flex: 1;
  min-width: 0;
  padding: 0 5px;
}
  </style>